import Image from "next/image"
import Link from "next/link"

export type PromoBannerModel = {
  readonly ctaLabel: string
  readonly href: string
  readonly kicker: string
  readonly title: string
}

/** Renders only when a published Admin banner exists — never an empty shell. */
export const PromoBanner = ({ banner, image }: { readonly banner: PromoBannerModel; readonly image?: { readonly alt: string; readonly src: string } }) => (
  <aside className="promo-banner" aria-label="캠페인 배너">
    <div className="promo-banner-copy">
      <p className="promo-banner-kicker">{banner.kicker}</p>
      <p className="promo-banner-title">{banner.title}</p>
    </div>
    <Link className="promo-banner-cta" href={banner.href}>
      {banner.ctaLabel}
    </Link>
    {image === undefined ? null : (
      <span className="promo-banner-product">
        <Image alt={image.alt} height={160} src={image.src} unoptimized width={160} />
      </span>
    )}
  </aside>
)
